import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Root, PriceDetail, FlightInfo } from "./types";

export interface FlightDetailsState {
  // Selected flight data
  selectedFlight?: Root | null;
  selectedPriceDetail?: PriceDetail | null;
  onwardFlight: Root[];
  returnFlight: Root[];
  // Filtered flight data
  filteredOnwardData: Root[];
  filteredReturnData: Root[];
  // Flight details for display
  flightDetails?: {
    departure: FlightInfo | null;
    return: FlightInfo | null;
    layover: any[];
    totalDuration: string;
    stops: number;
  };
  
  // Pricing information
  pricing?: {
    baseFare: number;
    taxes: number;
    totalAmount: number;
    currency: string;
    fareType: string;
    refundable: boolean;
    cancellationPolicy: string;
  };
  
  // Baggage information
  baggage?: {
    checkin: number;
    hand: number;
    checkinUnit: string;
    handUnit: string;
  };
  
  // Booking status
  booking?: {
    isBooked: boolean;
    bookingId: string;
    bookingRef: string;
    status: 'pending' | 'confirmed' | 'cancelled' | 'failed';
    confirmationNumber: string;
  };
  
  // Loading states
  loading?: {
    flightDetails: boolean;
    pricing: boolean;
    booking: boolean;
  };
  
  // Error states
  error?: {
    flightDetails: string | null;
    pricing: string | null;
    booking: string | null;
  };
}

  const initialState: FlightDetailsState = {
    onwardFlight: [],
    returnFlight: [],
    filteredOnwardData: [],
    filteredReturnData: [],
    flightDetails: {
      departure: null,
      return: null,
      layover: [],
      totalDuration: '',
      stops: 0,
    },
  };

const flightDetailsSlice = createSlice({
  name: 'flightDetails',
  initialState,
  reducers: {
    setOnwardFlight: (state, action: PayloadAction<Root[]>) => {
      state.onwardFlight = action.payload;
    },
    setReturnFlight: (state, action: PayloadAction<Root[]>) => {
      state.returnFlight = action.payload;
    },
    
    // Set filtered onward data
    setFilteredOnwardData: (state, action: PayloadAction<Root[]>) => {
      state.filteredOnwardData = action.payload;
    },
    
    // Set filtered return data
    setFilteredReturnData: (state, action: PayloadAction<Root[]>) => {
      state.filteredReturnData = action.payload;
    },
    
    // Set flight details
    setFlightDetails: (state, action: PayloadAction<{
      departure: FlightInfo;
      return?: FlightInfo;
      layover: any[];
      totalDuration: string;
      stops: number;
    }>) => {
      state.flightDetails = {
        ...action.payload,
        return: action.payload.return || null,
      };
    },
  },
});

export const { 
  setOnwardFlight, 
  setReturnFlight, 
  setFilteredOnwardData, 
  setFilteredReturnData, 
  setFlightDetails 
} = flightDetailsSlice.actions;

export default flightDetailsSlice.reducer;
